import numeral from 'numeral'
import React, { ComponentType, useState } from 'react'
import { FormattedDate, FormattedMessage } from 'react-intl'
import { Button } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding-bottom: 24px;
`

const Title = styled.h1`
  margin-bottom: 24px;
  font-size: 23px;
  line-height: 38px;
  font-weight: bold;

  ${up('sm')} {
    margin-bottom: 24px;
    font-size: 26px;
    line-height: 37px;
  }
`

const Tagline = styled.h5`
  color: #757d88;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  text-transform: uppercase;
  margin-bottom: 24px;

  ${up('sm')} {
    margin-bottom: 16px;
  }
`

const Description = styled.div`
  padding-bottom: 40px;
  line-height: 28px;
  
  ${up('sm')} {
    padding-bottom: 32px;
    
  }
`

const Pricing = styled.div`
  padding-bottom: 24px;
  

  ${up('sm')} {
    padding-bottom: 24px;
  }
`

const Price = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  line-height: 25px;
`

const BulletList = styled.div`
  display: flex;
`

const BulletItem = styled.div`
  flex: 1 1 auto;
`

const BulletTitle = styled.h6`
  margin-bottom: 10px;
  font-family: 600;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
`

const BulletText = styled.p`
  margin: 0;
  color: #0078c9;
  font-size: 18px;
`

const AvailableAt = styled.p`
  margin: 0;
  color: #757d88;
  font-size: 14px;
`

const capitalize = (s: any) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

interface Props {
  property: any
}

export const Extract: ComponentType<Props> = ({ property }) => {
  const [collapsed, setCollapsed] = useState(true)
  const toggleCollapsed = () => setCollapsed(!collapsed)

  const hasAreaTotal = !!property.area.total
  const hasAreaBuilt = !!property.area.built
  const hasAvailability = !!property.availability

  return (
    <Wrapper>
      <Title>{property.name}</Title>
      <Tagline>{property.principalNotes.split(',').join(' · ')}</Tagline>
      <Pricing>
        {!!property.sale?.price && (
          <Price>
            <>
              {numeral(property.sale.price).format('$0,0')} {property.currency}
            </>
          </Price>
        )}
        {!!property.rent?.monthPrice && (
          <Price>
            <>
              {numeral(property.rent.monthPrice).format('$0,0')} {property.currency}/mes
            </>
          </Price>
        )}
      </Pricing>
      {(hasAreaTotal || hasAreaBuilt || hasAvailability) && (
        <BulletList>
          {hasAreaTotal && (
            <BulletItem>
              <BulletTitle>Terreno</BulletTitle>
              <BulletText>{property.area.total} m²</BulletText>
            </BulletItem>
          )}
          {hasAreaBuilt && (
            <BulletItem>
              <BulletTitle>Construcción</BulletTitle>
              <BulletText>{property.area.built} m²</BulletText>
            </BulletItem>
          )}
          {hasAvailability && (
            <BulletItem>
              <BulletTitle>Entrega</BulletTitle>
              <BulletText>
                {property.availability === 'future' && property.availableAt ? (
                  <>
                    <FormattedDate value={property.availableAt} month="long">
                      {(str: string) => capitalize(str)}
                    </FormattedDate>{' '}
                    <FormattedDate value={property.availableAt} year="numeric" />
                  </>
                ) : (
                  <FormattedMessage id={`availability.${property.availability}`} />
                )}
              </BulletText>
            </BulletItem>
          )}
        </BulletList>
      )}
    </Wrapper>
  )
}
